<template>
    <div class="up-model">
        <Spin size="large" fix :show="isComfirm">
            <Icon
                type="ios-loading"
                size="18"
                class="demo-spin-icon-load"></Icon>
            <div>Please wait a moment...</div>
        </Spin>
        <div class="title-box">
            <!-- <div class="m-title">3D avatars and voices</div> -->

            <div class="s-title">Choose your own avatar and voice.</div>
        </div>
        <div class="up-content">
            <div class="content" ref="contentRef">
                <div class="select-box box-width">
                    <div class="select" @click="isOpen = !isOpen">
                        <div class="select-content">
                            <div class="text"  v-line-clamp="1">{{ activeObj.languageType }}</div>
                            <div class="arrow-icon">
                                <Icon type="ios-arrow-up" v-if="isOpen" />
                                <Icon type="ios-arrow-down" v-else />
                            </div>
                        </div>
                    </div>
                    <div class="select-audio-dropdown" v-if="isOpen">
                        <ul class="select-dropdown-list">
                            <li
                                class="select-item"
                                :class="
                                    item.languageType == activeObj.languageType
                                        ? 'active'
                                        : ''
                                "
                                v-for="(item, index) in toneList"
                                :key="index"
                                @click="setLanguageType(item)">
                                <div class="select-l">
                                    <div class="sl-icon">
                                        <img
                                            src="@/assets/select.png"
                                            v-if="
                                                item.languageType ==
                                                activeObj.languageType
                                            "
                                            alt="" />
                                    </div>
                                    <div class="contet" v-line-clamp="1">
                                        {{ item.languageType }}
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="select-box">
                    <div
                        class="select"
                        @click="isOpen = !isOpen"
                        :class="showErr ? 'err' : ''">
                        <div class="select-content">
                            <div class="text"  v-line-clamp="1">{{ selectObj.languageName }}</div>
                            <div class="arrow-icon">
                                <Icon type="ios-arrow-up" v-if="isOpen" />
                                <Icon type="ios-arrow-down" v-else />
                            </div>
                        </div>
                        <div class="select-audio-dropdown2" v-if="isOpen">
                            <ul class="select-dropdown-list">
                                <li
                                    class="select-item"
                                    :class="
                                        item.languageName ==
                                        selectObj.languageName
                                            ? 'active'
                                            : ''
                                    "
                                    v-for="(item, index) in toneSubList"
                                    :key="index"
                                    @click="setLanguageName(item)">
                                    <div class="select-l">
                                        <div class="sl-icon">
                                            <img
                                                src="@/assets/select.png"
                                                v-if="
                                                    item.languageName ==
                                                    selectObj.languageName
                                                "
                                                alt="" />
                                        </div>
                                        <div class="contet" v-line-clamp="1">
                                            {{ item.languageName }}
                                        </div>
                                    </div>
                                    <div class="select-r">
                                        <div class="sex">
                                            <img
                                                src="@/assets/man.png"
                                                alt=""
                                                v-if="item.languageSex == 1" />
                                            <img
                                                src="@/assets/woman.png"
                                                alt=""
                                                v-else />
                                        </div>
                                        <div
                                            class="tone"
                                            @click.stop="play(item)">
                                            <img
                                                src="@/assets/tone.png"
                                                alt=""
                                                v-show="!item.selectPlay" />
                                            <img
                                                src="@/assets/tone.gif"
                                                alt=""
                                                v-show="item.selectPlay" />
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div class="tone" @click.stop="play(selectObj)">
                    <img
                        src="@/assets/tone.png"
                        alt=""
                        v-show="!selectObj.selectPlay" />
                    <img
                        src="@/assets/tone.gif"
                        alt=""
                        v-show="selectObj.selectPlay" />
                </div>
            </div>

            <div class="avatar" v-if="figureList.length">
                <Carousel
                    v-model="avatar"
                    :autoplay="false"
                    dots="none"
                    arrow="always">
                    <CarouselItem
                        v-for="(group, groupIndex) in groupedFigureList"
                        :key="groupIndex">
                        <div class="avatar-carousel">
                            <div
                                class="item"
                                :class="figureObj.id == item.id ? 'active' : ''"
                                v-for="(item, index) in group"
                                :key="index"
                                @click="changeFigure(item)">
                                <img :src="item.imageUrl" alt="" />
                            </div>
                        </div>
                    </CarouselItem>
                </Carousel>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, watch, computed, onUnmounted, nextTick } from "vue";
import {
    VoiceList,
    FigureList,
    SaveDocFigure,
    generateKnowledge,
    generatePlay,
} from "@/api";
import { useStore } from "vuex";
import { useMixinMobileDevice } from "@/mixins/mobileDevice";
const { mobileDevice, Orientation } = useMixinMobileDevice();
const store = useStore();
const audio = ref(null);
const isOpen = ref(false);
const toneSubList = ref([]);
const toneList = ref([]);
const figureList = ref([]);
const activeObj = ref({});
const selectObj = ref({});
const figureObj = ref({});
const showErr = ref(false);
const fileId = computed(() => store.state.file.fileId);
const avatar = ref(0);
const isGuide = computed(() => store.state.app.isGuide);
const voiceList = ref([
    {
        languageType: "English (US)",
        items: [
            {
                bid: "1963547050283974681",
                languageCode: "en-US",
                languageName: "en-US-Journey-D",
                languageType: "English (US)",
                languageSex: "1",
                languageUrl:
                    "https://storage.googleapis.com/ppt_talk/voices/en-US-Journey-D.wav",
            },
            {
                bid: "1963547050283974683",
                languageCode: "en-US",
                languageName: "en-US-Journey-F",
                languageSex: "2",
                languageType: "English (US)",
                languageUrl:
                    "https://storage.googleapis.com/ppt_talk/voices/en-US-Journey-F.wav",
            }
        ],
    },
]);

const contentRef = ref(null);
const groupedFigureList = computed(() => {
    const groups = [];
    for (let i = 0; i < figureList.value.length; i += 4) {
        groups.push(figureList.value.slice(i, i + 4));
    }
    return groups;
});

const upStep = computed(() => store.state.app.upStep);

const props = defineProps({
    isComfirm: {
        type: Boolean,
        default: false,
    },
});
watch(
    () => upStep.value,
    (newValue) => {
        if (newValue == 2) {
            getVoiceList();
            getFigureList();
        }
    }
);


onMounted(() => {
    window.addEventListener("click", handleClickOutside);
});
onUnmounted(() => {
    // 清理音频资源
    console.log(55555555555555555);
    window.removeEventListener("click", handleClickOutside);
    if (audio.value) {
        audio.value.pause();
        audio.value = null;
    }
});
const handleClickOutside = (event) => {
    // 检查点击的元素是否在 `contentRef` 引用的元素之外
    console.log(contentRef.value);
    if (!contentRef.value) return;
    console.log(contentRef.value.contains(event.target));
    if (contentRef.value && !contentRef.value.contains(event.target)) {
        // 执行你想要的操作，比如关闭组件
        console.log("点击在 content 之外的区域");
        isOpen.value = false;
    }
};

const changeFigure = (item) => {
    figureObj.value = item;
};

const getFigureList = () => {
    //获取形象列表
    FigureList().then((res) => {
        if (res.code == 200) {
            console.log(res);
            nextTick(() => {
                figureList.value = res.data;
                figureObj.value = figureList.value[0];
            });
        }
    });
};

const getVoiceList = () => {
    VoiceList().then((res) => {
        console.log(res);
        if (res.code == 200) {
            toneList.value = res.data.map((el, i) => {
                el.items.map((item, j) => {
                    item.languageType = el.languageType;
                    return item;
                });

                return el;
            });

            if(isGuide.value) {
                toneList.value = voiceList.value
            }
            activeObj.value = toneList.value[0];
            toneSubList.value = activeObj.value.items.map((el) => {
                el.selectPlay = false;
                return el;
            });
            console.log(toneSubList.value);
            selectObj.value = toneSubList.value[0];

            console.log(selectObj.value);
        }
    });
};
const setLanguageType = (item) => {
    activeObj.value = item;
    toneSubList.value = activeObj.value.items;
    selectObj.value = toneSubList.value[0];
    showErr.value = false;
    pauseAudio();
};

const setLanguageName = (item) => {
    showErr.value = false;
    selectObj.value = item;
};
const playAudio = () => {
    if (audio.value) {
        audio.value.play();
    }
};
const pauseAudio = () => {
    if (audio.value) {
        audio.value.removeEventListener("ended", pauseAudio);
        toneSubList.value.forEach((el) => {
            el.selectPlay = false;
        });
        audio.value.pause();
    }
};
const play = (item) => {
    if (Object.keys(item).length == 0) {
        item.selectPlay = false;
        audio.value.pause();
        return false;
    }
    if (item.selectPlay) {
        item.selectPlay = false;
        audio.value.pause();
        return false;
    } else {
        pauseAudio();
    }
    item.selectPlay = true;

    audio.value = new Audio(item.languageUrl);
    audio.value.addEventListener("ended", pauseAudio);
    playAudio();
};

const saveDocFigure = () => {
    //获取保存的形象数据
    return new Promise((resolve, reject) => {
        SaveDocFigure({
            documentId: fileId.value,
            imageId: figureObj.value.id,
            wide: 104 * 2,
            high: 124 * 2,
            x: 0,
            y: 352,
            voices: selectObj.value.languageName,
            sex: selectObj.value.languageSex,
            languageCode: selectObj.value.languageCode,
            languageType: selectObj.value.languageType,
            local: selectObj.value.local,
        }).then((res) => {
            console.log(res);
            console.log("resaaaaaaaaaaaaa");
            resolve();
        });
    });
};

const comfirm = () => {
    console.log("hahahhahahahha");

    return new Promise(async (resolve, reject) => {
        await saveDocFigure();
        // await generateKnowledge({
        //     documentId: fileId.value,
        // });
        await generatePlay({
            documentId: fileId.value,
        });
        resolve();
    });
};

defineExpose({ comfirm });
</script>
<style lang="less" scoped>
.up-model {
    height: 440px;
    .title-box {
        .m-title {
            font-size: 20px;
            font-weight: 500;
            color: #31302eff;
        }
        .s-title {
            font-size: 14px;
            color: #4945FFFF;
            text-align: center;
        }
    }

    .up-content {
        .content {
            display: flex;
            margin-top: 24px;
            .select-box {
                display: flex;
                align-items: center;
                position: relative;
                &.box-width {
                    width: 400px;
                    margin-right: 12px;
                }
                .select {
                    height: 30px;
                    line-height: 30px;
                    width: 400px;
                    border: 1px solid #8d8da866;
                    border-radius: 4px;
                    cursor: pointer;
                    padding-left: 12px;
                    &:hover {
                        border-color: #4945ffff;
                    }
                    &.err {
                        border: 1px solid #f80505ce;
                    }
                    &-content {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .text {
                            font-size: 16px;
                            width: 300px;
                        }
                        .arrow-icon {
                            width: 30px;
                            height: 30px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                    }
                }

                .icon {
                    width: 30px;
                    height: 30px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                    margin-left: 12px;
                    &:hover {
                        background: #f0f0f0ff;
                    }
                    img {
                        width: 16px;
                        height: 16px;
                    }
                }
            }
        }
    }
}

.select-audio-dropdown {
    width: 400px;
    z-index: 9;
    background: #fff;
    position: absolute;
    will-change: top, left;
    transform-origin: center top;
    top: 36px;
    left: 0px;
    border-radius: 8px;
    box-shadow: 0 0 8px 0 #00000026;
    padding: 8px 0;
    .select-dropdown-list {
        max-height: 200px;
        overflow-y: scroll;
        .select-item {
            height: 36px;
            line-height: 36px;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            &:hover {
                background: #f7f8faff;
            }

            &.active {
                background: #f7f8faff;
            }

            .select-l {
                display: flex;
                justify-content: space-between;
                .sl-icon {
                    width: 40px;
                    height: 36px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    img {
                        width: 16px;
                        height: 16px;
                    }
                }
                .contet {
                    font-size: 14px;
                    color: #31302eff;
                    font-weight: 400;
                    width: 350px;
                }
            }
        }
    }
}
.select-audio-dropdown2 {
    width: 400px;
    z-index: 9;
    background: #fff;
    position: absolute;
    will-change: top, left;
    transform-origin: center top;
    top: 36px;
    left: 0px;
    border-radius: 8px;
    box-shadow: 0 0 8px 0 #00000026;
    padding: 8px 0;
    .select-dropdown-list {
        max-height: 200px;
        overflow-y: scroll;
        .select-item {
            height: 36px;
            line-height: 36px;
            cursor: pointer;
            display: flex;
            justify-content: space-between;
            &:hover {
                background: #f7f8faff;
            }

            &.active {
                background: #f7f8faff;
            }

            .select-l {
                display: flex;
                justify-content: space-between;
                .sl-icon {
                    width: 40px;
                    height: 36px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    img {
                        width: 16px;
                        height: 16px;
                    }
                }
                .contet {
                    font-size: 14px;
                    color: #31302eff;
                    font-weight: 400;
                    width: 150px;
                }
            }
            .select-r {
                display: flex;
                .sex {
                    width: 36px;
                    height: 36px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    img {
                        width: 16px;
                        height: 16px;
                    }
                }
            }
        }
    }
}
.tone {
    width: 40px;
    height: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    &:hover {
        background: #f0f0f0ff;
    }
    img {
        width: 16px;
        height: 16px;
    }
}

.avatar {
    margin-top: 20px;
    .avatar-carousel {
        display: flex;
        justify-content: space-between;
        margin-right: 10px;
        .item {
            width: 214px !important;
            height: 249px !important;
            background-color: #e6e6e6ff;
            overflow: hidden;
            border-radius: 8px;
            cursor: pointer;
            &.active {
                border: 1px solid #4945ffff;
            }
            &:hover {
                border: 1px solid #4945ffff;
            }
        }
    }
}
</style>
